import { Stack } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import GeneralSettings from "./GeneralSettings";

const SettingsContainer = () => {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={2} sx={{ px: "1.3rem", width: "100%" }}>
        <GeneralSettings />
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default SettingsContainer;
